import { useLocation } from 'react-router-dom';
import { useUIStore, selectPageTitle } from '../stores/ui.store';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const HEX_ID_RE = /^[0-9a-f]{16,}$/i;

/**
 * Returns the page title — either the explicit override from the UI store,
 * or the best human-readable segment of the current pathname (skipping UUIDs
 * and hex IDs).
 */
export function usePageTitle(): string {
  const storeTitle = useUIStore(selectPageTitle);
  const { pathname } = useLocation();

  if (storeTitle) return storeTitle;

  const segments = pathname.split('/').filter(Boolean);

  // Walk backward to find the first segment that isn't a UUID/hex-id or "edit"
  for (let i = segments.length - 1; i >= 0; i--) {
    const seg = segments[i]!;
    if (seg === 'edit' || seg === 'create') continue;
    if (UUID_RE.test(seg) || HEX_ID_RE.test(seg)) continue;
    return seg.charAt(0).toUpperCase() + seg.slice(1).replace(/-/g, ' ');
  }

  const last = segments[segments.length - 1] || '';
  return last.charAt(0).toUpperCase() + last.slice(1).replace(/-/g, ' ');
}
